import { domain } from 'config/google';
import type { NextRouter } from 'next/router';
import type { GetServerSidePropsContext } from 'next/types';
import { isMobile } from '@blofin/blofin-utils/func/helper';
import BlofinNative from 'sdk';

export function toRedirectHome() {
  return toRedirect('/');
}

function toRedirect(destination: string) {
  return { redirect: { destination, permanent: false } } as const;
}

export function toServerHeader(req: GetServerSidePropsContext['req'], isDemoTrading: number, locale?: string) {
  return {
    token: req?.cookies?.token || '',
    lang: locale || 'en',
    'x-forwarded-for':
      req.headers['x-real-ip'] || req.headers['cf-connecting-ip'] || req.headers['true-client-ip'] || '',
    'fp-request-id': req?.cookies?.requestId || '',
    isDemoTrading,
  };
}

export function ensureDemoTrading(ctx: string, act_id: string) {
  if (ctx === 'demo-trading') return 2;
  if (/^d-\d+$/.test(act_id)) return 1;
  return 0;
}

export function generateRedirectUrl({ host, local, path }: Record<'host' | 'local' | 'path', string>) {
  local = (local || 'en') === 'en' ? '' : `/${local}`;
  path = `/login?redirect=activity${local}${path}`;
  return `${host.startsWith('localhost') ? `http://${host}` : `https://${host}`}${local === 'en' ? '' : `/${local}`}${path}`;
}

export function getBasisServer(req: GetServerSidePropsContext['req'], act_id = '', shouldLogin = true) {
  const isDemoTrading = ensureDemoTrading(req.cookies['Global-UserViewType'] || '', act_id);

  if (!isDemoTrading) {
    const isPhone = isMobile(req.headers['user-agent'] || '');
    const isApp = BlofinNative.isApp(req.headers['user-agent'] || '');
    return { isPhone, isApp, isDemoTrading, act_id, host: '' };
  }

  // const token = req.cookies['token'] || '';
  // if (!token && shouldLogin) {
  //   return { isPhone: false, isApp: false, isDemoTrading, act_id: DOME_TRADING_ID, host: req.headers.host || '' };
  // }

  act_id = act_id.replace(/^d-/, '');

  return {
    isPhone: isMobile(req.headers['user-agent'] || ''),
    isApp: BlofinNative.isApp(req.headers['user-agent'] || ''),
    isDemoTrading,
    act_id,
    host: '',
  };
}

export const legalAct = (act_id: string, url: string) => {
  // if (act_id === DOME_TRADING_ID) {
  //   return toRedirect(url);
  // }
  if (!Number(act_id)) {
    return toRedirectHome();
  }
};

export const isServer = () => typeof window === 'undefined';

export const fileDownload = (url: string) => {
  const aTag = document.createElement('a');
  aTag.style.display = 'none';
  aTag.href = url;
  aTag.download = 'blockfin.png';
  document.body.append(aTag);
  aTag.click();
  document.body.removeChild(aTag);
};

export const getHerfConfig = (router: NextRouter) => {
  const path = router.asPath.split('?')[0];
  return router.locales
    ?.map((item) => {
      return {
        href: `${domain}${router.basePath}${item === 'en' ? '' : `/${item}`}${path === '/' ? '' : path}`,
        hrefLang: item,
      };
    })
    .concat({
      href: `${domain}${router.basePath}${path === '/' ? '' : path}`,
      hrefLang: 'x-default',
    });
};

export function smoothScroll({
  ele,
  offsetTop,
  scrollToTop = false,
}: {
  ele: HTMLElement | null;
  offsetTop: number;
  scrollToTop?: boolean;
}) {
  const startScrollTop = window.scrollY;
  const distance = scrollToTop ? -startScrollTop : (ele?.offsetTop || 0) - offsetTop - startScrollTop; // 滚动到顶部的距离
  const duration = 1000; // 动画持续时间，单位为毫秒
  let startTime: number | null = null;

  const scroll = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // 计算动画进度，范围在0到1之间
    const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress; // 缓动函数

    window.scrollTo(0, startScrollTop + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(scroll);
    }
  };

  requestAnimationFrame(scroll);
}
